import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sm/wds-react';
import { createURL } from '@sm/utils';
import { T, defineMessages } from '@sm/intl';

const COPY = defineMessages({
  SIGN_UP: {
    id: 'SignUpCTA.signUpButton',
    defaultMessage: 'Sign Up',
    description:
      '[Type: Label][Vis.: high] - This is the Sign Up button on the header.',
  },
});

export const SignUpCTA = ({
  variant,
  size,
  color,
  stretched,
  className,
  params,
}) => {
  return (
    <Button
      data-testid="SignUpCTA__Btn"
      variant={variant}
      size={size}
      color={color}
      stretched={stretched}
      className={className}
      href={createURL('/user/sign-up/', params)}
    >
      <T desc={COPY.SIGN_UP} />
    </Button>
  );
};

SignUpCTA.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  stretched: PropTypes.bool,
  className: PropTypes.string,
  params: PropTypes.oneOfType([PropTypes.object]),
};

SignUpCTA.defaultProps = {
  variant: 'ghost',
  size: 'sm',
  color: 'alt',
  stretched: false,
  className: '',
  params: null,
};

export default SignUpCTA;
